import { type ReactNode, useEffect } from 'react'
import { useTrackEvent } from '@retailer-platform/dashboard/analytics'
import { getTrackingEntry } from './registry'
import { useElementTrackingEnabled } from './useElementTrackingEnabled'

export const MarketingToolingClickTrackingProvider = ({ children }: { children: ReactNode }) => {
  const trackingEnabled = useElementTrackingEnabled()
  const trackEvent = useTrackEvent()

  useEffect(() => {
    if (!trackingEnabled) return

    const onClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return

      const trackedElement = event.target.closest('[data-track-name]')
      const entry = getTrackingEntry(
        trackedElement?.closest('[data-track-surface]')?.getAttribute('data-track-surface') ?? null,
        trackedElement?.getAttribute('data-track-name') ?? null
      )
      if (!entry) return

      trackEvent({
        id: 'marketing_tooling_element.interaction',
        description: 'Marketing tooling element clicked',
        data: entry,
      })
    }

    document.addEventListener('click', onClick, true)
    return () => document.removeEventListener('click', onClick, true)
  }, [trackingEnabled, trackEvent])

  return <>{children}</>
}
